// extracted by mini-css-extract-plugin
export var cardHeader = "_ur-0";
export var reorderHandle = "_ur-3";
export var titleArea = "_ur-1";
export var titleAreaWithHandle = "_ur-2";